"use client";
import { useRouter } from "next/navigation";
import type { ReactNode } from "react";
import { use, useEffect, useRef } from "react";

import { UserContext } from "@/contexts/user-context";

export const ServerPageListener = ({ children }: { children: ReactNode }) => {
  const router = useRouter();
  const { currentUserPublicKey } = use(UserContext);
  const loadedRef = useRef(false);

  // Note: when the currentUserPublicKey changes, we need to refresh the router and wallet page completely
  useEffect(() => {
    // Avoid refresh on the first load
    if (!loadedRef.current) {
      loadedRef.current = true;
      return;
    }
    router.refresh();
  }, [router, currentUserPublicKey]);

  return children;
};
